import { EventOrder, ParsedEventOrder } from './types';

const parse = (item: EventOrder) =>
  Object.freeze({
    client_fio: item!.client_fio || '',
    competence_id: item!.competence_id || '',
    competence_new: item!.competence_new || '',
    cost_max: item!.cost_max || '',
    edu_cats: item!.edu_cats || [],
    edu_durations: item!.edu_durations || [],
    edu_forms: item!.edu_forms || [],
    id: item!.id || '',
    modules: item!.modules || [],
    prof_sphere_id: item!.prof_sphere_id || '',
    profession_id: item!.profession_id || '',
    program_name: item!.program_name || '',
    students_count: item!.students_count || '',
    user_comment: item!.user_comment || '',
  });

export const parseEventOrder = (data: EventOrder): ParsedEventOrder => parse(data);



// WEBPACK FOOTER //
// ./src/services/api/event-orders/utils/parseEventOrder.ts